// Validate required environment variables
if (!process.env.REACT_APP_API_BASE_URL && process.env.NODE_ENV === 'production') {
}

export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  API_PATH: process.env.REACT_APP_API_PATH || 'api/v1',

  FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGEING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
  FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,

  STRIPE_PUBLISHABLE_API_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
};
